import { useEffect, useState } from "react"
import { Row } from "reactstrap"

const AuthPlasticsPreview = props => {
  const [consumptionItems, setconsumptionItems] = useState([])
  const [importPurchase, setImportPurchase] = useState("")

  useEffect(() => {
    var items = null
    if (props.data.consumptionItemsNames) {
      items = props.data.consumptionItemsNames.map((item, index) => {
        return " " + item + ", "
      })
      setconsumptionItems(items)
    }

    if (props.data.other_selected_items_names != undefined) {
      let mergedItems = props.data.consumptionItemsNames.concat(props.data.other_selected_items_names)
      var allItems = mergedItems.map((item) => {
        return " " + item + ", " })
      
      setconsumptionItems(allItems)
    }
   
    
    var import_purchase_mapping = {
      import: "Import and Use Plastic Carry Bags",
      purchase: "Purchase and Use Plastic Carry Bags",
      import_single: "Import and Use Single-Use Plastics",
      purchase_single: "Purchase and Use Single-Use Plastics"
    }
    if (props.data.import_purchase) {
      setImportPurchase(import_purchase_mapping[props.data.import_purchase])
    }
  }, [props.data])

  return (
    <>
      <Row>
        <h5>Application Details</h5>
        <table className="table table-striped table-responsive">
          <thead>
            <tr>
              <th>Item</th>
              <th>Value</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Plastic Type </td>
              <td>
                {props.data.plastic_type_name == "Other"
                  ? props.data.other_plastic_type
                  : props.data.plastic_type_name}
              </td>
            </tr>

            <tr>
              <td>For Import or Purchase</td>
              <td>{importPurchase}</td>
            </tr>
            
            {props.data.origin? <tr>
              <td>Country of Origin</td>
              <td>{props.data.origin}</td>
            </tr> : <tr>
              <td>Local Supplier Company</td>
              <td>{props.data.supplier_company_name}</td>
            </tr> }
            
            <tr>
              <td>Quantity Measure</td>
              <td>{props.data.measure_name}</td>
            </tr>

            <tr>
              <td>Quantity</td>
              <td>{props.data.quantity}</td>
            </tr>

            <tr></tr>
            <tr>
              <td>Usage</td>
              <td>
                {props.data.usage == "Other"
                  ? props.data.other_consumption_area
                  : props.data.usage}
              </td>
            </tr>

            <tr>
              <td>Items to be packaged</td>
              <td>{consumptionItems}</td>
            </tr>

            <tr>
              <td>Usage for Finished Product</td>
              <td>{props.data.plasticsFinishedUsage == "Both"? "Both Local & Export" : props.data.plasticsFinishedUsage}</td>
            </tr>

            <tr>
              <td>Description</td>
              <td>{props.data.description}</td>
            </tr>
          </tbody>
        </table>
      </Row>
    </>
  )
}

export default AuthPlasticsPreview
